import { Component, Input, OnInit, inject } from '@angular/core';
import { ThemeService } from 'stream-chat-angular';
import { ButtonSize, ButtonState, ButtonType } from '../../../assets/types/dtoTypes';
import { NgClass, NgIf, NgStyle } from '@angular/common';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  imports: [
    NgStyle,
    NgClass,
    NgIf
  ],
  standalone: true
})
export class ButtonComponent implements OnInit {
  private themeService = inject(ThemeService);

  currentTheme: string;

  @Input() label: string;

  @Input() type: ButtonType;

  @Input() borderColor: string;

  @Input() size: ButtonSize;

  @Input() state: ButtonState;

  @Input() showLeftIcon: boolean = false;

  @Input() showRightIcon: boolean = false;

  @Input() leftIcon: string = '';

  @Input() rightIcon: string = '';

  @Input() isFullWidth = false;

  @Input() isOpaque: boolean = false;

  @Input() isFullHeight: boolean = false;



  constructor() {
  }

  isDisabled() {
    return this.state === 'disabled';
  }

  ngOnInit(): void {
    this.themeService.theme$.subscribe( theme => {
      this.currentTheme = theme;
    } );
  }

  getAssets( iconName: string ): string {
    return this.currentTheme === 'light'
      ? `../assets/icons/${iconName}-light.svg`
      : `../assets/icons/${iconName}-dark.svg`;
  }

  getClasses() {
    const classes = [ 'btn', this.type, this.size, this.state ];
    if ( this.isOpaque && this.type === 'ghost' ) {
      classes.push( 'opaque-ghost' );
    }
    return classes.filter( Boolean );
  }

}

